import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActiveDirectoryComponent } from './active-directory/active-directory.component';
import { ActiveDirectoriesComponent } from './active-directories.component';
import { ActiveDirectoryAddComponent } from './active-directory-add/active-directory-add.component';


const routes: Routes = [
  {
    path: "", component: ActiveDirectoriesComponent, children: [
      { path: "ADConnection", component: ActiveDirectoryComponent },
      { path: "Add", component: ActiveDirectoryAddComponent },
      { path: "", redirectTo: 'ADConnection', pathMatch: 'full' },


    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActiveDirectoryRoutingModule { }
